import { useState, useEffect, Fragment } from 'react';
import { Flex } from '../../component-library';
import { PatientFacialDetection } from '../../components';
import { useReceiveMessage } from '../../context/messageContext';
import { useTestContext } from '../../context/testContext';
import Arrow from '../../assets/img/upwards-arrow.svg';

const VisualAcuityTestPatient = ({ logmarType }) => {
  const { testData } = useTestContext();
  const [currentLogmarSize, setCurrentLogmarSize] = useState(0);
  const [currentLogmarContent, setCurrentLogmarContent] = useState([]);
  const [highlightedCharacter, setHighlightedCharacter] = useState('');
  const messageFromOptician = useReceiveMessage();
  const [logmarData, setLogmarData] = useState({});

  const hasContentChanged = (newLogmarContent, newLogmarSize) => {
    return newLogmarContent !== currentLogmarContent || newLogmarSize !== currentLogmarSize;
  };

  useEffect(() => {
    if (hasContentChanged(logmarData.characters, logmarData.size)) {
      setCurrentLogmarSize(logmarData.size);
      setCurrentLogmarContent(logmarData.characters?.split(''));
    }
  }, [logmarData]);

  useEffect(() => {
    if (messageFromOptician?.type !== 'highlightLogmarCharacter') return;
    const charToHighlight = messageFromOptician.content?.slice(-1);
    setHighlightedCharacter(charToHighlight);
  }, [messageFromOptician]);

  useEffect(() => {
    switch (messageFromOptician.type) {
      case 'resizeLogmar':
        setLogmarData({
          size: messageFromOptician.content.fontSize,
          distance: messageFromOptician.content.distanceReferenceInMM,
          characters: messageFromOptician.content.logmarCharacters,
        });
        break;
      case 'visualAcuityTest':
        setLogmarData({
          size: messageFromOptician.content.fontSize,
          distance: messageFromOptician.content.distanceFromScreen,
          characters: messageFromOptician.content.logmarCharacters,
        });
        break;
      default:
        break;
    }
  }, [messageFromOptician]);

  return (
    <Flex>
      <PatientFacialDetection testMode={testData.testMode} />
      <Flex bg='white' width='100vw' alignItems='center' height='100vh' justifyContent='center' style={{ zIndex: '9' }}>
        <Flex style={logmarType === 'Crowded' ? { borderWidth: currentLogmarSize / 8, borderStyle: 'solid', padding: currentLogmarSize / 3 } : null}>
          {currentLogmarContent?.map((char, idx) => {
            return (
              <Fragment key={`logmar-char-${idx}-${char}`}>
                <Flex style={{ position: 'relative' }}>
                  <span
                    style={{
                      fontFamily: 'OpticianSans',
                      fontSize: `${currentLogmarSize}px`,
                      whiteSpace: 'pre',
                    }}
                  >
                    {char}
                  </span>
                  {highlightedCharacter === char && (
                    <img
                      src={Arrow}
                      alt='arrow highlighting character'
                      style={{
                        height: currentLogmarSize,
                        position: 'absolute',
                        top: `${currentLogmarSize * (1 + (logmarType === 'Crowded' ? 0.75 : 0.25))}px`,
                        left: '50%',
                        transform: 'translateX(-50%)',
                      }}
                    />
                  )}
                </Flex>
              </Fragment>
            );
          })}
        </Flex>
      </Flex>
    </Flex>
  );
};

export default VisualAcuityTestPatient;
